import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { Pie } from 'react-chartjs-2'

PieChart.propTypes = {
    heading: PropTypes.string,
    labels: PropTypes.array,
    data: PropTypes.array,
    heigth: PropTypes.number,
    legend: PropTypes.bool,
}
PieChart.defaultProps = {
    heading: '',
    labels: [],
    data: [],
    heigth: 270,
    legend: false,
};

function PieChart(props) {

    const getColour = (subject) => {
        switch (subject) {
            case "biology":
                return '#17bd59'
            case "chemistry":
                return '#3396be'
            case "maths":
                return '#e96969'
            case "physics":
                return '#e4ac13'
            case "english":
                return '#6f98a9'
            case "cyber":
                return '#FE9F65'        
            default:
                return '#996fd6';
        }
    }

    const data = {
        labels: props.labels,
        datasets: [{
            data: props.data,
            backgroundColor: [
                // getColour(props.subject),
                '#17bd59',
                '#FF6384',
               
            ],
            hoverBackgroundColor: [
                // getColour(props.subject),
                '#17bd59',
                '#FF6384',
                
            ],
        }],
    };

    const options = {
        legend: {
            "display": props.legend,
        },
        tooltips: {    
            callbacks: {       
              label: function(tooltipItem, data) {   
                var dataset = data.datasets[tooltipItem.datasetIndex];     
                var meta = dataset._meta[Object.keys(dataset._meta)[0]];             
                var total = meta.total;                
                var currentValue = dataset.data[tooltipItem.index];
                var percentage = parseFloat((currentValue/total*100).toFixed(1)); 
                return  ' (' + percentage + '%)';         
            },         
             title: function(tooltipItem, data) {  
                return data.labels[tooltipItem[0].index];    
            }           
         }
       },
    }

    return (
        <div>
        {/* <Card> */}
            <div className="width-auto">
                <div className="width-100 mb-2 text-center CarddTitle">{props.heading}</div>
                <div className="chart-wrapper">
                    <Pie data={data} options={options} height={props.height} />
                </div>
            </div>
        {/* </Card>
   */}
        </div>
    )
}

export default PieChart;

